// function to update alternative paths for a current path
export const updateAlternativePath = (alterativePath: string, currentPath: string): string => {
  if (!alterativePath.includes('/:')) {
    return alterativePath
  }
  /* 
    updating dynamic alternative path on locale switch using current path
    & new path as per navigation. Eg.
    /de/post/:slug -> /post/test-blog
    /post/:slug    -> /de/post/test-blog
  */
  const alternativePathSegmants = alterativePath.split('/')
  const currentPathSegmants = currentPath.split('/')
  let i = alternativePathSegmants.length - 1
  let j = currentPathSegmants.length - 1
  while (i >= 0 && j >= 0) {
    if (alternativePathSegmants[i].includes(':')) {
      alternativePathSegmants[i] = currentPathSegmants[j]
    }
    i -= 1
    j -= 1
  }
  return alternativePathSegmants.join('/')
}

// locale converted to zendesk widget accepted locales
// https://developer.zendesk.com/documentation/classic-web-widget-sdks/chat-widget/customising-the-widget/changing-the-widget-language/
export const zendeskLocaleMap: Record<string, string> = {
  en_US: 'en',
  de_DE: 'de',
  es_MX: 'es',
  zh_CN: 'zh_CN',
  zh_TW: 'zh_TW',
}
